import { FrameProduct, SizeLabel } from '../';

export function IsMediumSize(product: FrameProduct): product is FrameProduct {
  return product.drawableObject.sizeLabel === SizeLabel.M;
}
